export default {
  state: {
    show: false,
    dataList: [
      { id: 1, name: 'john' },
      { id: 2, name: 'james' },
    ],
  },

  mutations: {
    contentShow(state) {
      state.show = !state.show
    },
  },

  actions: {
    contentShow(context) {
      context.commit('contentShow')
    },
  },

  getters: {
    notShow(state) {
      return !state.show
    },
    getDataList: (state) => {
      return state.dataList.filter((todo) => todo.name)
    },
  },
}
